import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-white text-gray-800 border-t border-gray-200">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img src="https://static.readdy.ai/image/260cb4a7e92398667a2a2f5c835f3622/99728b562c9b9993c2c423ddde30401b.png" alt="Piramit Antrepo" className="h-12 mb-4" />
            <p className="text-gray-600 text-sm leading-relaxed mb-4">
              1974'ten beri güvenilir lojistik ve antrepo hizmetleri sunuyoruz.
            </p>
            <div className="flex gap-3">
              <a href="https://www.facebook.com/people/Piramit-Antrepo/61586828411474/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-[#1877F2] rounded-full flex items-center justify-center hover:bg-[#0d65d9] transition-colors text-white">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="https://www.linkedin.com/company/piramit-antrepo-lojistik/posts/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-[#0A66C2] rounded-full flex items-center justify-center hover:bg-[#004182] transition-colors text-white">
                <i className="ri-linkedin-fill"></i>
              </a>
              <a href="https://www.instagram.com/piramitantrepo/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-[#8b1538] rounded-full flex items-center justify-center hover:bg-[#6d1029] transition-colors text-white">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="https://www.youtube.com/" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 bg-[#FF0000] rounded-full flex items-center justify-center hover:bg-[#cc0000] transition-colors text-white">
                <i className="ri-youtube-fill"></i>
              </a>
              <a href="https://www.tiktok.com/@piramitantrepo" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-black rounded-full flex items-center justify-center hover:bg-gray-800 transition-colors text-white">
                <i className="ri-tiktok-fill"></i>
              </a>
              <a href="https://wa.me/905324469672" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-[#25D366] rounded-full flex items-center justify-center hover:bg-[#1da851] transition-colors text-white">
                <i className="ri-whatsapp-fill"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#1a1f4d]">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-600 hover:text-[#8b1538] transition-colors text-sm whitespace-nowrap">{t('nav.home')}</Link></li>
              <li><Link to="/hakkimizda" className="text-gray-600 hover:text-[#8b1538] transition-colors text-sm whitespace-nowrap">{t('nav.about')}</Link></li>
              <li><Link to="/hizmetler" className="text-gray-600 hover:text-[#8b1538] transition-colors text-sm whitespace-nowrap">{t('nav.services')}</Link></li>
              <li><Link to="/blog" className="text-gray-600 hover:text-[#8b1538] transition-colors text-sm whitespace-nowrap">{t('nav.blog')}</Link></li>
              <li><Link to="/iletisim" className="text-gray-600 hover:text-[#8b1538] transition-colors text-sm whitespace-nowrap">{t('nav.contact')}</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#1a1f4d]">{t('footer.contact')}</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-[#8b1538] mt-1"></i>
                <span className="text-gray-600">{t('footer.address')}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-[#8b1538]"></i>
                <a href="tel:02124463750" className="text-gray-600 hover:text-[#8b1538] transition-colors whitespace-nowrap">(0212) 446 37 50</a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-printer-line text-[#8b1538]"></i>
                <span className="text-gray-600 whitespace-nowrap">(0212) 446 37 48</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-whatsapp-line text-[#8b1538]"></i>
                <a href="https://wa.me/905324469672" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-[#8b1538] transition-colors whitespace-nowrap">(0532) 446 96 72</a>
              </li>
            </ul>
          </div>

          {/* Working Hours */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#1a1f4d]">{t('footer.workingHours')}</h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li className="flex justify-between">
                <span>{t('footer.weekdays')}</span>
              </li>
              <li className="flex justify-between">
                <span>{t('footer.saturday')}</span>
              </li>
              <li className="flex justify-between">
                <span>{t('footer.sunday')}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-200">
        <div className="container mx-auto px-4 py-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-2 text-sm text-gray-500">
            <p>{t('footer.copyright')}</p>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-[#8b1538] transition-colors whitespace-nowrap">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
